export default "__VITE_ASSET__D9qEA08l__"